<template>
  <div>
    <div class="video message-text__wrap">
      <video
        ref="inlineVideo"
        :src="url"
        muted
        playsInline
        @click="onClick"
      />
      <woot-modal :show.sync="show" :on-close="onClose">
        <video
          :src="url"
          :key="url"
          controls
          playsInline
          class="modal-video skip-context-menu"
        />
      </woot-modal>
    </div>
    <div v-if="!!caption" class="caption-content message-text__wrap">
      <div class="text-content">
        {{ caption }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    caption: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      show: false,
      lastTime: 0,
      wasPlaying: false,
    };
  },
  methods: {
    onClose() {
      this.show = false;
    },
    onClick() {
      this.show = true;
    },
    saveVideoState() {
      const video = this.$refs.inlineVideo;
      if (video) {
        this.lastTime = video.currentTime;
        this.wasPlaying = !video.paused;
      }
    },
    restoreVideoState() {
      const video = this.$refs.inlineVideo;
      if (video) {
        video.currentTime = this.lastTime || 0;
        if (this.wasPlaying) {
          video.play();
        }
      }
    },
  },
  mounted() {
    this.restoreVideoState();
  },
  updated() {
    this.restoreVideoState();
  },
  beforeUpdate() {
    this.saveVideoState();
  },
};
</script>